<template>
    <div class="mb-3 remote-readiness-item">
        <div class="card border-0" style="border-radius: 6px;">
            <div class="card-body p-3">
                <div class="d-flex align-items-start justify-content-between">
                    <div class="d-flex align-items-center mb-1">
                        <div class="mr-2"><user-avatar :avatarURL="staff.avatar_src"></user-avatar></div>
                        <div class="staff-name-text">
                            <div class="d-flex align-items-center">
                                <div class="card-name mr-2">
                                    {{ staff.display_name || staff.name }}
                                </div>
                                <small class="text-muted">{{
                                    staff.group_name
                                }}</small>
                            </div>
                            <div class="card-desc">{{ staff.designation }}</div>
                        </div>
                    </div>
                    <a
                        class="border-0 p-0 ml-1"
                        :href="`mailto:${this.staff.email}`"
                    >
                        <i
                            class="fas fa-envelope mail-icon"
                            style="color: #4f5153"
                        ></i>
                    </a>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                        <span
                            v-for="i of calculatedUserRemoteReadiness"
                            class="mr-1"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="12"
                                width="12"
                            >
                                <circle
                                    cx="6"
                                    cy="6"
                                    r="6"
                                    :fill="circleColour"
                                />
                            </svg>
                        </span>
                        <span
                            v-for="i of 6 - calculatedUserRemoteReadiness"
                            class="mr-1"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="12"
                                width="12"
                            >
                                <circle cx="6" cy="6" r="6" fill="#EAEAEA" />
                            </svg>
                        </span>
                    </div>
                    <div class="text-muted" @click="toggleCard">
                        <button
                            class="btn btn-dropdown"
                            style="line-height: 1.4; padding: 1px 5px !important;"
                            data-toggle="collapse"
                            :data-target="`#remoteReadiness-${staff.id}`"
                            aria-expanded="false"
                            :aria-controls="`remoteReadiness-${staff.id}`"
                        >
                            <i
                                class="fas"
                                style="color: #4f5153"
                                :class="{
                                    'fa-chevron-down': !expand,
                                    'fa-chevron-up': expand
                                }"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="collapse" :id="`remoteReadiness-${staff.id}`">
            <div class="card card-body border-0 py-2 px-4">
                <div>
                    <ul class="list-unstyled pl-0">
                        <li
                            v-for="item in getRemoteReadinessLabels(
                                remoteReadiness
                            )"
                        >
                            <!-- <i
                                class="fas fa-check-circle mr-2"
                                :class="{
                                    'text-success': item.passed,
                                    'text-grey-1': !item.passed
                                }"
                            ></i> -->
                            <img
                                :src="
                                    item.passed
                                        ? '/images/Icon-check-green.svg'
                                        : '/images/icon-check-gray.svg'
                                "
                                class="mr-2 rounded-circle"
                                alt="check"
                            />
                            <span class="list-name">{{ item.title }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserRemoteReadinessHelper from "../RemoteReadiness/UserRemoteReadinessHelper";

export default {
    props: ["staff"],

    data() {
        return {
            remoteReadiness: {},
            calculatedUserRemoteReadiness: "",
            expand: false
        };
    },

    computed: {
        circleColour() {
            if (this.calculatedUserRemoteReadiness > 5) {
                return "#82DF6B";
            } else if (this.calculatedUserRemoteReadiness > 3) {
                return "#FFDB53";
            } else {
                return "#FF8383";
            }
        }
    },

    methods: {
        toggleCard: _.debounce(async function() {
            this.expand = !this.expand;
        }, 200),

        async getUserRemoteReadiness() {
            const res = await axios.get(
                `/staffs/${this.staff.id}/remote-readiness`
            );
            this.remoteReadiness = res.data.data;
            this.calculatedUserRemoteReadiness = UserRemoteReadinessHelper.calculateRemoteReadiness(
                this.remoteReadiness
            );
        },

        getRemoteReadinessLabels(remoteReadiness) {
            return UserRemoteReadinessHelper.getRemoteReadinessLabels(
                remoteReadiness
            );
        }
    },

    mounted() {
        this.getUserRemoteReadiness();
    }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/core/mixins";

.remote-readiness-item {
    border-bottom: 1px solid #dce2ed;

    .card {
        .card-name {
            color: #303030;
            font-family: "Open Sans";
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 22px;
        }

        .card-desc {
            color: #7d8fa6;
            font-family: "Open Sans";
            font-size: 10px;
            letter-spacing: 0;
            line-height: 22px;
        }

        .card-bottom {
            margin-left: 42px;
        }

        .card-dropdown {
            border: 1px solid #dce2ed;
            border-radius: 4px;
            background-color: #ffffff;
            padding-left: 12px;
            color: #808fa4;
        }

        .btn-dropdown {
            border: 1px solid #d4d9e2;
        }

        .list-name {
            color: #303030;
            font-family: "Open Sans";
            font-size: 14px;
            letter-spacing: 0;
            line-height: 22px;
        }
    }
}

.staff-name-text {
    line-height: 1.25;
}

.mail-icon {
    font-size: 1.2rem;
}
</style>
